<template>
  <!--srcviewscompanydetailsbusinessvuehtmlStart-->

  <div id="defaultId1" class="bn_root">
    <div id="cc18ed" class="udb507 u22483 pb20">
      <div id="g2ede8" class="operations-content mb10 operations_content_top">
        <div id="gf7b16" class="operations-head">
          <span class="text_head detail_title_20">{{
            $t("ContentTabs.Operations")
          }}</span>
        </div>
        <div class="operations-box">
          <div class="operations-box-left">
            <el-descriptions :colon="false" :column="1">
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">
                    <div class="label_text">
                      {{ $t("Operations.LineofBusiness") }}
                    </div>
                  </div>
                  <!-- v-if="userType && hasPower == 1" -->
                  <div
                    :class="[
                      editcontent == 'Line of Business'
                        ? 'edit_icon_dis'
                        : 'edit_icon',
                    ]"
                  >
                    <svg
                      t="1718263375162"
                      @click="edit('Line of Business')"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="11104"
                      width="34px"
                      height="34px"
                    >
                      <path
                        d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                        fill="#1290C9"
                        p-id="11105"
                      ></path>
                    </svg>
                  </div>
                </template>
                <div class="operations-label-text">
                  <div
                    v-if="editcontent == 'Line of Business'"
                    style="position: relative"
                  >
                    <el-input
                      autocomplete="off"
                      clearable
                      type="textarea"
                      autosize
                      v-model="Busines"
                    ></el-input>
                    <div class="dingwei" tyle="text-align: center;">
                      <span
                        class="contclass"
                        @click="(editcontent = ''), (Busines = '')"
                        >{{ $t("MyAccount.Change") }}</span
                      >
                      <span class="jiange">|</span>
                      <span class="contclass" @click="SavedOperations('1')">{{
                        $t("MyAccount.Save")
                      }}</span>
                    </div>
                  </div>
                  <div v-else>{{ LineofBusiness }}</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :colon="false" :column="1">
              <el-descriptions-item v-if="BusinessTerritories != '-'">
                <template slot="label">
                  <div class="operations-label-title">
                    <div class="label_text">
                      {{ $t("Operations.BusinessTerritories") }}
                    </div>
                  </div>
                </template>
                <div class="operations-label-text">
                  {{ BusinessTerritories }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item v-if="ImportExport != '-'">
                <template slot="label">
                  <div class="operations-label-title">
                    <div class="label_text">
                      {{ $t("Operations.ImportExport") }}
                    </div>
                  </div>
                </template>
                <div class="operations-label-text">
                  {{ ImportExport }}
                  <span
                    @click="gotoimport"
                    v-if="ImportExport == 'Yes'"
                    class="ViewMore contclass"
                    >{{ $t("Operations.Viewtradeinfo") }}</span
                  >
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="operations-box-right">
            <el-descriptions :colon="false" :column="1">
              <el-descriptions-item>
                <template slot="label">
                  <div class="operations-label-title">
                    <div class="label_text">
                      {{ $t("Operations.ProductsServices") }}
                    </div>
                  </div>
                  <div
                    :class="[
                      editcontentSever == 'Products/Services'
                        ? 'edit_icon_dis'
                        : 'edit_icon',
                    ]"
                  >
                    <!-- v-if="userType && hasPower == 1" -->
                    <svg
                      t="1718263375162"
                      @click="editcontentSever = 'Products/Services'"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="11104"
                      width="34px"
                      height="34px"
                    >
                      <path
                        d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                        fill="#1296db"
                        p-id="11105"
                      ></path>
                    </svg>
                  </div>
                </template>
                <div class="operations-label-text">
                  <div
                    v-if="editcontentSever == 'Products/Services'"
                    style="position: relative"
                  >
                    <el-input
                      autocomplete="off"
                      clearable
                      type="textarea"
                      autosize
                      v-model="ProductsServicescahnge"
                    ></el-input>
                    <div class="dingwei" tyle="text-align: center;">
                      <span
                        class="contclass"
                        @click="
                          (editcontentSever = ''), (ProductsServicescahnge = '')
                        "
                        >{{ $t("MyAccount.Change") }}</span
                      >
                      <span class="jiange">|</span>
                      <span class="contclass" @click="SavedOperations('2')">{{
                        $t("MyAccount.Save")
                      }}</span>
                    </div>
                  </div>
                  <ul class="blue_dot_list" v-else>
                    <li v-for="(item, index) in ProductsServices?.split(';')" :key="index">{{ index !== ProductsServices?.split(';').length - 1 ? item + ';' : item }}</li>
                  </ul>
                </div>
              </el-descriptions-item>
              -
            </el-descriptions>
          </div>
        </div>
      </div>
      <!--  @click="powerArr[0]?.hasPrivilege ? '' : $bus.$emit('show-permission-dialog', '您没有权限访问该功能！')" :class="powerArr[0]?.hasPrivilege ? '' : 'vaguesuo'"-->
      <div class="">
        <!-- :class="powerArr[0]?.hasPrivilege?'operations-content ':'vague'" -->
        <div id="g2ede8" class="operations-content">
          <div id="gf7b16" class="operations-head">
            <span class="text_head detail_title_20">
              {{ $t("Operations.Products") }}</span
            >
          </div>
          <el-table
            :data="tableData"
            style="width: 100%"
            empty-text="Please Upload Data"
            class="table_X table_font_size_14 bn_table"
          >
            <el-table-column
              :label="$t('Operations.ProductImage')"
              width="200"
              prop="Product Img"
              align="center"
            >
              <template slot-scope="scope">
                <el-upload
                  v-if="scope.$index == inputIndex"
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-change="imgchange"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span v-else class="flex_center">
                  <img
                    class="bn_product_table_img"
                    :src="
                      'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' +
                      scope.row.imgUrl
                    "
                    alt=""
                  />
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="SKU" prop="SKU" width="200" align="center">
            <template slot-scope="scope">
              <el-input   autocomplete="off" clearable v-if="scope.$index == inputIndex" v-model="scope.row.sku"></el-input>
              <span v-else>{{ scope.row.sku }}</span>
            </template>
          </el-table-column> -->
            <el-table-column
              :label="$t('Operations.ProductName')"
              prop="ProductName"
              width="300"
            >
              <template slot-scope="scope">
                <el-input
                  autocomplete="off"
                  v-if="scope.$index == inputIndex"
                  clearable
                  v-model="scope.row.name"
                ></el-input>
                <span v-else>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              :label="$t('Operations.ProductDescription')"
              prop="ProductDescription"
            >
              <template slot-scope="scope">
                <el-input
                  autocomplete="off"
                  v-if="scope.$index == inputIndex"
                  clearable
                  v-model="scope.row.description"
                ></el-input>
                <span v-else>{{ scope.row.description }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('Operations.Details')"
              width="200"
              prop=""
              align="center"
            >
              <template slot-scope="scope">
                <!--  -->
                <a
                  v-if="powerArr[2]?.hasPrivilege"
                  class="flex_center"
                  :href="
                    'mailto:service@csibizinfo.com?subject=information need to correct&body=Customer service, hello: %0D%0Aand Our company  isinterestedin ' +
                    scope.row.name +
                    ' of ' +
                    $parent.$parent.companyName +
                    'and  needs to %0D%0Aand obtain the price of the product. thank you '
                  "
                >
                  <svg
                    t="1719539255609"
                    class="icon bn_product_table_icon"
                    @click="handleEdit(scope.$index, scope.row)"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4711"
                    width="28px"
                    height="28px"
                  >
                    <path
                      d="M964.48 459.632l-94.784-82.416V84.608c0-12.368-8.24-20.608-20.608-20.608h-661.44c-12.368 0-20.624 8.24-20.624 20.608v298.784l-94.784 76.24c-6.176 4.128-8.24 10.304-8.24 16.48V950.08c0 12.368 8.24 20.608 20.608 20.608h865.44c12.384 0 20.624-8.24 20.624-20.608V476.128c0-6.192-2.08-12.368-6.192-16.48z m-96.848-26.784l49.456 41.216-49.44 32.96v-74.176zM208.24 105.216h618.192v430.656l-212.256 146.304H420.48l-212.24-146.304V105.216zM167.04 436.96v72.112l-47.392-32.96 47.392-39.152z m-61.808 78.304l274.064 187.52-274.08 206.048V515.28zM146.432 929.44L420.48 723.392h191.648l276.112 206.064H146.432z m783.024-20.608L655.392 702.784l274.064-187.52v393.584zM744 414.288H290.672v41.232H744v-41.216z m0-103.008H290.672v41.2H744v-41.2z m-329.696-103.04h-123.632v41.216h123.632v-41.216z"
                      fill="#1296db"
                      p-id="4712"
                    ></path>
                  </svg>
                </a>
                <svg
                  v-else
                  @click="
                    $bus.$emit(
                      'show-permission-dialog',
                      '您没有权限访问该功能！',
                    )
                  "
                  t="1719539255609"
                  class="icon bn_product_table_icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4711"
                  width="28px"
                  height="28px"
                >
                  <path
                    d="M964.48 459.632l-94.784-82.416V84.608c0-12.368-8.24-20.608-20.608-20.608h-661.44c-12.368 0-20.624 8.24-20.624 20.608v298.784l-94.784 76.24c-6.176 4.128-8.24 10.304-8.24 16.48V950.08c0 12.368 8.24 20.608 20.608 20.608h865.44c12.384 0 20.624-8.24 20.624-20.608V476.128c0-6.192-2.08-12.368-6.192-16.48z m-96.848-26.784l49.456 41.216-49.44 32.96v-74.176zM208.24 105.216h618.192v430.656l-212.256 146.304H420.48l-212.24-146.304V105.216zM167.04 436.96v72.112l-47.392-32.96 47.392-39.152z m-61.808 78.304l274.064 187.52-274.08 206.048V515.28zM146.432 929.44L420.48 723.392h191.648l276.112 206.064H146.432z m783.024-20.608L655.392 702.784l274.064-187.52v393.584zM744 414.288H290.672v41.232H744v-41.216z m0-103.008H290.672v41.2H744v-41.2z m-329.696-103.04h-123.632v41.216h123.632v-41.216z"
                    fill="#1296db"
                    p-id="4712"
                  ></path>
                </svg>
              </template>
            </el-table-column>
          </el-table>
          <!-- v-if="userType && hasPower == 1" -->
          <div class="last-colmun">
            <div
              v-if="inputIndex == -1"
              @click="addInput(tableData.length)"
              class="contclass"
            >
              <div class="last-colmun-add">
                <span class="mr10">+</span>
                <span>{{ $t("Operations.Addproductinformation") }}</span>
                <svg
                    t="1749001947538"
                    class="icon bn_root_icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6416"
                    width="20"
                    height="20"
                    style="vertical-align: middle;"
                  >
                    <path
                      d="M528 1024C793.6 1024 1024 793.6 1024 528 1024 230.4 793.6 0 528 0 230.4 0 0 230.4 0 528 0 793.6 230.4 1024 528 1024zM512 64c246.4 0 448 201.6 448 448s-201.6 448-448 448S64 758.4 64 512 265.6 64 512 64z"
                      fill="#FFC800"
                      p-id="6417"
                    ></path>
                    <path
                      d="M512 256m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
                      fill="#FFC800"
                      p-id="6418"
                    ></path>
                    <path
                      d="M640 768h-64V384h-160v32h64v352h-64v32h224z"
                      fill="#FFC800"
                      p-id="6419"
                    ></path></svg>
                <div class="Financial-icon-box">
                  {{ $t("Operations.Showcaseyourcompany") }}
                </div>
              </div>
            </div>
            <div v-else style="text-align: center">
              <span @click="CancelAdd()" class="contclass">
                {{ $t("MyAccount.Change") }}</span
              >
              <span class="jiange">|</span>
              <span class="contclass" @click="uptateProduct">{{
                $t("MyAccount.Save")
              }}</span>
            </div>
          </div>
          <div class="page_i_box">
            <Page
              :totalFont="true"
              :total="page.total"
              :pageSize.sync="page.pageSize"
              :currentPage="page.pageNo"
              @onPageChange="onPageChangeList"
            ></Page>

            <div class="search_rsult_txt line_2">
              {{ page.pageNo }}-{{ page.pageSize }} of over
              <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results for "{{
                $t("Operations.Products")
              }}"
            </div>
          </div>
          <!-- <div v-if="inputIndex == -1" style="text-align: center; padding: 20px" class="show_AllHeight">
          <span class="contclass show_All" v-if="this.page.total>this.page.pageSize" @click="apptablelist">Show More</span>
        </div> -->
        </div>
      </div>
      <!-- <PermissionDialog></PermissionDialog> -->
      <ReLogin :reLoginPop="reLoginVis"></ReLogin>
    </div>
  </div>
  <!--srcviewscompanydetailsbusinessvuehtmlEnd-->
</template>
<script>
// interfaceCode
//

//importEnd

// interfaceCode

// interfaceCode
//importStart

import gui_link_content from "../../../components/gui_link_content/gui_link_content.vue";
import gui_scroll_x from "../../../components/gui_scroll_x/gui_scroll_x.vue";
//importEnd
// import PermissionDialog from '@/components/power/PermissionDialog.vue';
import ReLogin from "../../../components/ReLogin.vue";
import Page from "@/components/page/index.vue";

import {
  getPartPrivilege,
  getCompanyOperating,
  addProducts,
  editCompanyPartialInfo,
} from "@/api/companyApi";
import { UploadProductImg } from "@/api/userApi";
export default {
  name: "",
  props: {},
  mounted() {
    this.getlist();
    this.getPartPrivilege();
    if (this.userInfo.userInfo.userType == 3) {
      this.userType = true;
    }
    this.$emit("UpdatamarkTotalList", []);
  },
  components: {
    gui_link_content,
    gui_scroll_x,
    // PermissionDialog,
    ReLogin,
    Page,
  },
  data() {
    return {
      reLoginVis: false,
      userType: false,
      SkuCode: "",
      powerArr: [],
      IsSkuCode: false,
      LineofBusiness: "",
      BusinessTerritories: "",
      hasPower: 0,
      Busines: "",
      ProductsServicescahnge: "",
      ImportExport: "",
      ProductsServices: "",
      imageUrl: "",
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 5,
        total: 0,
      },
      inputIndex: -1,
      editcontent: "",
      editcontentSever: "",
      dialogImageUrl: "",
      dialogVisible: false,
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      // insertData
      // srcviewscompanydetailsbusinessvueDataStart

      // hangyefenxiKey
      hangyefenxiKey: 0,
      imageName: "",
      // srcviewscompanydetailsbusinessvueDataEnd
    };
  },
  methods: {
    // IsSkuCodeMethod(){
    //   if(this.powerArr[1]?.hasPrivilege){
    //     this.IsSkuCode=true
    //   }else{
    //     this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');
    //   }
    // },
    getPartPrivilege() {
      getPartPrivilege({
        moduleId: 419,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "421")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "422")[0];
        this.powerArr[2] = res.data.filter((item) => item.id == "423")[0];
        this.powerArr[3] = res.data.filter((item) => item.id == "453")[0];
      });
    },
    SavedOperations(value) {
      // FORM DATE类型
      const params = new URLSearchParams();
      params.append("aaaId", this.$route.query.id3a);
      params.append("type", value);
      params.append(
        "data",
        value == "1" ? this.Busines : this.ProductsServicescahnge,
      );
      if (value == "1") {
        if (this.Busines == "") {
          this.$message.error("Cannot be empty");
        } else {
          editCompanyPartialInfo(params).then((res) => {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.editcontent = "";
            this.Busines = "";
          });
        }
      } else {
        if (this.ProductsServicescahnge == "") {
          this.$message.error("Cannot be empty");
        } else {
          editCompanyPartialInfo(params).then((res) => {
            this.editcontentSever = "";
            this.ProductsServicescahnge = "";
            this.$message({
              message: res.msg,
              type: "success",
            });
          });
        }
      }
    },
    changSeach() {},

    getlist() {
      const id3a = this.$route.query.id3a;
      getCompanyOperating({
        id3a: id3a,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.ProductsServices = res.data.productsAndServices;
            this.LineofBusiness = res.data.lineOfBusiness;
            this.BusinessTerritories = res.data.businessTerritories;
            this.ImportExport = res.data.importExportFlag > 0 ? "Yes" : "No";
            this.tableData = res.data.productsVO.rows;
            this.hasPower = res.data.hasPower;
            this.page.total = res.data.productsVO.total;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    uptateProduct() {
      console.log(this.tableData[this.inputIndex]);

      let params = [
        {
          aaaId: this.$route.query.id3a,
          type: 3,
          customAccount: this.userInfo.userInfo.email,
          dataJson: {
            imgUrl: this.imageUrl,
            sku: "3123",
            name: this.tableData[this.inputIndex]?.name,
            description: this.tableData[this.inputIndex]?.description,
          },
          status: 1,
        },
      ];
      params.map((item) => {
        item.dataJson = JSON.stringify(item.dataJson);
      });

      addProducts(params).then((res) => {
        this.$message({
          message:
            "The product you submitted needs to be reviewed by backend personnel, and after successful review, it will appear on the page",
          type: "success",
          duration: 6000,
        });
      });
      this.inputIndex = -1;
      this.getlist();
    },
    handleAvatarSuccess(res, file) {},
    imgchange(file) {
      // this.imageName = file.name;
      const reader = new FileReader();

      reader.onload = (event) => {
        const binaryData = event.target.result; // 获取二进制数据

        const formData = new FormData();
        formData.append("avatarfile", new Blob([binaryData]), file.name);
        UploadProductImg(formData).then((res) => {
          if (res.code == 200) {
            this.imageUrl =
              "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
              res.data;

            // 更新 localStorage
          } else {
            this.$message.error(res.msg);
          }
        });
      };

      reader.readAsArrayBuffer(file.raw); // 启动读取
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }
      if (!isLt2M) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }

      return isJPG && isLt2M;
    },

    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getlist();
    },

    apptablelist() {
      this.page.pageSize + 5;
      this.getlist();
    },
    CancelAdd() {
      this.inputIndex = -1;
      this.getlist();
    },
    edit(content) {
      this.editcontent = content;

      //   this.tableData.push({ ...this.tableData[index-1] });
    },
    // insertMethod
    // srcviewscompanydetailsbusinessvueMethodStart
    // returnPage
    handleEdit(index, row) {},

    addInput(index) {
      if (this.powerArr[3]?.hasPrivilege) {
        this.inputIndex = index;
        this.tableData.push({});
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    gotoimport() {
      if (this.powerArr[0]?.hasPrivilege) {
        this.$router.push({
          path: "import&Export",
          params: {
            id: this.$route.params.id,
          },
          query: {
            id3a: this.$route.query.id3a,
            companyCountry: this.$route.query.companyCountry,
            SACode1: this.$route.query.SACode1,
            companyCountryEn: this.$route.query.companyCountryEn,
            idpower: 430,
            companyCountryEn: this.countryCode1,
            keword: this.$route.query.keword,
          },
        });
        // window.location.reload();
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    // srcviewscompanydetailsbusinessvueMethodEnd
  },
  computed: {},
};
</script>
<style scoped>
.ua915f {
  margin-right: 0;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  margin-top: 0;
  margin-left: 0;
  margin-bottom: 0;
}

.operations-head {
  height: 32px;
  color: #1a2332;
  font-family: "Arial Bold";
}

.operations-head /deep/ .el-input__inner {
  height: 44px;
  box-shadow: 0 2px 9px 0 rgba(30, 33, 45, 0.14);
  border-radius: 4px;
  border: 9px solid #8497ab;
}

.text_head {
  font-size: 26px;
  height: 27px;
  font-family: "Arial Bold";
  color: #1290c9;
}

.operations-content {
  padding: 30px 40px 0;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding-bottom: 0;
}

.operations-box {
  margin-top: 30px;
  display: flex;
}

/deep/.el-descriptions {
  font-size: 14px;
}

/deep/.el-descriptions__title {
  font-size: 22px;
  font-family: "Arial Bold";
  color: #1a2332;
  text-align: left;
  font-style: normal;
}

/deep/ .el-descriptions-item__label {
  display: block !important;
  margin-right: 30px !important;
  /* padding-bottom: 2.142857142857143em !important; */
}

.operations-label-title {
  width: max-content;
  min-width: 160px;
  line-height: 42px;
}

.label_text {
  width: 200px;
  font-size: 20px;
  line-height: 26px;
  font-family: "Arial";
  color: #666666;
  overflow-wrap: break-word;
  word-break: keep-all;
  white-space: normal;
}

.operations-label-text {
  font-size: 20px;
  font-family: "Arial";
  color: #1a2332;
  line-height: 30px;
  width: 100%;
}

.operations-label-text div,
.operations-label-text ul li,
.operations-label-text span{
  font-family: "Arial";
}

/deep/ .el-textarea__inner {
  padding: 8px 14px;
  font-size: 20px;
  color: #29445d;
  border-radius: 4px;
  border: 1px solid #cccccc;
}

.ViewMore {
  line-height: 26px;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 30px;
  cursor: pointer;
}

.operations-box-left {
  margin-right: 164px;
}

.bgyinying {
  height: 16px;
  width: 100%;
  background-color: #f5f5f5;
}

/deep/ .el-table {
  font-size: 16px;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.bn_root .jiange {
  display: inline-block;
  height: 20px;
  color: #cccccc;
  margin: 0 20px;
  font-size: 20px;
  line-height: 20px;
}

.bn_root .contclass {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  font-size: 20px !important;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table .cell {
  font-size: 16px;
  color: #1a2332;
  line-height: 26px;
}

.last-colmun {
  padding: 28px 0;
  border-bottom: 1px solid #cccccc;
}

.dingwei {
  position: absolute;
  top: -36px;
  right: 0;
}

.mr10 {
  margin-right: 11px;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-table .el-input__inner {
  height: 44px;
  line-height: 44px;
  color: #1a2332;
  border: 1px solid #8497ab;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 26px !important;
}

 
/deep/ .operations-box-right .el-descriptions-item__cell {
  padding-bottom: 0 !important;
}

/deep/ .avatar-uploader .el-upload {
  margin-top: 5px;
  margin-bottom: 5px;
  background: #f5f5f5;
  border: 1px dashed #cccccc;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #1290c9;
}

/deep/ .avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

/deep/ .avatar {
  width: 62px;
  height: 62px;
  display: block;
}

.input-str {
  width: 352px;
  font-size: 16px;
  color: #a2a9b0;
  line-height: 20px;
}

/deep/.el-input__inner:focus {
  border: 1px solid #8497ab;
}

.operations-content /deep/ .el-table .el-table__cell {
  /* padding: 0; */
}

.operations-content /deep/ .el-input .el-input__inner {
  border: 1px solid #8497ab;
}

/deep/ .el-table thead {
  height: 44px;
}

.edit_icon,
.edit_icon_dis {
  margin-left: -7px;
  margin-top: 16px;
}

.edit_icon path {
  fill: #1290c9;
}

.edit_icon_dis path {
  fill: #8497ab;
}

.edit_icon .icon,
.edit_icon_dis .icon {
  width: 34px;
  height: 34px;
}

.Financial-icon-box {
  display: none;
  width: 500px;
  position: absolute;
  left: 0px;
  top: -190px;
  z-index: 10;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 18px;
  color: #29445d;
  line-height: 28px;
}

.last-colmun-add {
  position: relative;
}

.last-colmun-add .bn_root_icon:hover + .Financial-icon-box {
  display: block;
}

.bn_root_icon {
  width: 20px;
  height: 20px;
}

.operations_content_top{
  padding-bottom: 30px;
}

.blue_dot_list {
  li{
    list-style-type: disc;
  }

  li:not(:first-child){
    margin: 4px 0;
  }

  ::marker{
      color: #1290c9 !important; 
  }
}


@media screen and (max-width: 1920px) {
  .ua915f {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .operations-head {
    height: 40px;
    margin-bottom: 15px;
  }

  .operations-head /deep/ .el-input__inner {
    height: 34px;
    box-shadow: 0 2px 7px 0 rgba(30, 33, 45, 0.14);
    border: 7px solid #8497ab;
  }

  .text_head {
    height: auto;
    font-size: 20px;
    line-height: 40px;
  }

  .operations-content {
    padding: 22px 30px 0;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.12);
  }

  .operations-box {
    margin-top: 0;
  }

  ::v-deep.el-descriptions {
    font-size: 12px;
  }

  ::v-deep.el-descriptions__title {
    font-size: 16px;
  }

  ::v-deep .el-descriptions-item__label {
    margin-right: 22px !important;
  }

  .operations-label-title {
    min-width: 120px;
    line-height: 32px;
  }

  .label_text {
    width: 160px;
    font-size: 16px;
    line-height: 20px;
  }

  .operations-label-text {
    font-size: 16px;
    line-height: 24px;
  }

  ::v-deep .el-textarea__inner {
    padding: 6px 10px;
    font-size: 16px;
  }

  .ViewMore {
    line-height: 20px;
    margin-left: 22px;
  }

  .operations-box-left {
    margin-right: 124px;
  }

  .bgyinying {
    height: 14px;
  }

  ::v-deep .el-table {
    font-size: 14px;
  }

  .bn_root .jiange {
    height: 15px;
    margin: 0 15px;
    font-size: 16px;
    line-height: 18px;
  }

  .bn_root .contclass {
    height: 18px;
    line-height: 18px;
    font-size: 16px !important;
  }

  ::v-deep .el-table .cell {
    font-size: 14px;
    line-height: 20px;
  }

  .last-colmun {
    padding: 21px 0;
  }

  .dingwei {
    top: -27px;
  }

  .mr10 {
    margin-right: 8px;
  }

  ::v-deep .el-table .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 10px !important;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
  }

  ::v-deep .avatar-uploader .el-upload {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  ::v-deep .avatar {
    width: 46px;
    height: 46px;
  }

  .input-str {
    width: 264px;
    font-size: 14px;
    line-height: 16px;
  }

  ::v-deep .el-table thead {
    height: 34px;
  }

  .edit_icon,
  .edit_icon_dis {
    margin-left: -6px;
    margin-top: 12px;
  }

  .edit_icon .icon,
  .edit_icon_dis .icon {
    width: 26px;
    height: 26px;
  }

  .Financial-icon-box {
    width: 376px;
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
    top: -146px;
    padding: 14px;
    font-size: 14px;
    line-height: 22px;
  }

  .bn_root_icon {
    width: 15px;
    height: 15px;
  }

  
  .operations_content_top{
    padding-bottom: 22px;
  }
}

@media screen and (max-width: 1439px) {
  .ua915f {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .operations-head /deep/ .el-input__inner {
    height: 44px;
    box-shadow: 0 2px 6px 0 rgba(30, 33, 45, 0.14);
    border: 6px solid #8497ab;
  }

  .text_head {
    font-size: 18px;
    height: 18px;
  }

  .operations-content {
    padding: 20px 26px 0;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
  }

  .operations-box {
    margin-top: 20px;
  }

  ::v-deep.el-descriptions {
    font-size: 12px;
  }

  ::v-deep.el-descriptions__title {
    font-size: 14px;
  }

  ::v-deep .el-descriptions-item__label {
    margin-right: 20px !important;
  }

  .operations-label-title {
    min-width: 108px;
    line-height: 28px;
  }

  .label_text {
    width: 134px;
    font-size: 14px;
    line-height: 18px;
  }

  .operations-label-text {
    font-size: 14px;
    line-height: 20px;
  }

  ::v-deep .el-textarea__inner {
    padding: 6px 9px;
    font-size: 14px;
  }

  .ViewMore {
    line-height: 18px;
    margin-left: 20px;
  }

  .operations-box-left {
    margin-right: 110px;
  }

  .bgyinying {
    height: 10px;
  }

  ::v-deep .el-table {
    font-size: 12px;
  }

  .bn_root .jiange {
    height: 12px;
    margin: 0 12px;
    font-size: 14px;
    line-height: 12px;
  }

  .bn_root .contclass {
    height: 16px;
    line-height: 16px;
    font-size: 14px !important;
  }

  ::v-deep .el-table .cell {
    font-size: 12px;
    line-height: 18px;
  }

  .last-colmun {
    padding: 18px 0;
  }

  .dingwei {
    top: -24px;
  }

  .mr10 {
    margin-right: 7px;
  }

  ::v-deep .el-table .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 18px !important;
  }

  ::v-deep .avatar-uploader-icon {
    font-size: 14px;
    width: 46px;
    height: 46px;
    line-height: 46px;
  }

  ::v-deep .avatar-uploader .el-upload {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  ::v-deep .avatar {
    width: 42px;
    height: 42px;
  }

  .input-str {
    width: 256px;
    font-size: 12px;
    line-height: 12px;
  }

  ::v-deep .el-table thead {
    height: 30px;
  }

  .edit_icon,
  .edit_icon_dis {
    margin-left: -5px;
    margin-top: 10px;
  }

  .edit_icon .icon,
  .edit_icon_dis .icon {
    width: 22px;
    height: 22px;
  }

  .Financial-icon-box {
    width: 336px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
    top: -140px;
    padding: 12px;
    font-size: 14px;
    line-height: 18px;
  }

  .bn_root_icon {
    width: 12px;
    height: 12px;
  }
  
  .operations_content_top{
    padding-bottom: 20px;
  }
}
</style>

<style>
.bn_table {
  overflow-y: auto;
  border: none;
  border-collapse: collapse;
}

.bn_table thead,
.bn_table .el-table__cell {
  min-height: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

.bn_table td,
.bn_table td.el-table__cell {
  min-height: 80px !important;
  height: 80px !important;
}

.bn_table .el-table__body-wrapper .el-table__row td:last-child,
.bn_table .el-table__header-wrapper th:last-child {
  border-right: none !important;
}

.bn_table::after {
  display: none !important;
}

.bn_table.el-table {
  overflow: hidden;
}

.bn_table .el-table__cell:first-child > .cell {
  padding-left: 20px !important;
}

.bn_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
  padding-right: 30px !important;
}

.bn_table
  .el-table__header-wrapper
  th.el-table__cell:nth-last-child(2)
  > .cell {
  padding-right: 30px !important;
}

.bn_product_table_img {
  width: 70px;
  height: 70px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.bn_table.el-table th .cell {
  font-size: 20px;
  line-height: 24px;
}

.bn_table.el-table td .cell {
  font-size: 18px;
  line-height: 20px;
}

.bn_product_table_icon {
  width: 28px;
  height: 28px;
}

.bn_table.el-table .el-input__inner {
  height: 50px;
  border-radius: 4px;
  font-size: 18px !important;
  line-height: 30px;
  border: 1px solid #8497ab;
}

.bn_root .el-textarea__inner {
  min-height: 50px !important;
  height: 100px !important;
}

@media screen and (max-width: 1920px) {
  .bn_table thead,
  .bn_table .el-table__cell {
    min-height: 44px !important;
    height: 44px !important;
  }

  .bn_table td,
  .bn_table td.el-table__cell {
    min-height: 50px !important;
    height: 50px !important;
  }

  .bn_table .el-table__cell:first-child > .cell {
    padding-left: 15px !important;
  }

  .bn_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 22px !important;
  }

  .bn_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 22px !important;
  }

  .bn_product_table_img {
    width: 40px;
    height: 40px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .bn_table.el-table th .cell {
    font-size: 16px;
    line-height: 22px;
  }

  .bn_table.el-table td .cell {
    font-size: 16px;
    line-height: 22px;
  }

  .bn_product_table_icon {
    width: 22px;
    height: 22px;
  }

  .bn_table.el-table .el-input__inner {
    height: 32px;
    font-size: 14px !important;
    line-height: 22px;
  }

  .bn_root .el-textarea__inner {
    min-height: 38px !important;
    height: 76px !important;
  }
}

@media screen and (max-width: 1439px) {
  .bn_table thead,
  .bn_table .el-table__cell {
    min-height: 32px !important;
    height: 32px !important;
  }

  .bn_table td,
  .bn_table td.el-table__cell {
    min-height: 54px !important;
    height: 54px !important;
  }

  .bn_table .el-table__cell:first-child > .cell {
    padding-left: 12px !important;
  }

  .bn_table .el-table__body-wrapper .el-table__cell:last-child > .cell {
    padding-right: 20px !important;
  }

  .bn_table
    .el-table__header-wrapper
    th.el-table__cell:nth-last-child(2)
    > .cell {
    padding-right: 20px !important;
  }

  .bn_product_table_img {
    width: 46px;
    height: 46px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .bn_table.el-table th .cell {
    font-size: 14px;
    line-height: 16px;
  }

  .bn_table.el-table td .cell {
    font-size: 14px;
    line-height: 16px;
  }

  .bn_product_table_icon {
    width: 18px;
    height: 18px;
  }

  .bn_table.el-table .el-input__inner {
    height: 32px;
    font-size: 14px !important;
    line-height: 20px;
  }

  .bn_root .el-textarea__inner {
    min-height: 32px !important;
    height: 68px !important;
  }
}
</style>
